// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=utf8,%3CsvgviewBox=%27003232%27xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpathstroke=%27rgba%28255,255,255%29%27stroke-width=%272%27stroke-linecap=%27round%27stroke-miterlimit=%2710%27d=%27M48h24M416h24M424h24%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(http://fonts.cdnfonts.com/css/sofia-pro);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Jost:wght@300;400;600&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @font-face {
  font-family: "Inter";
  src: url("/fonts/font.woff2") format("woff2"),
       url("/fonts/font.woff") format("woff");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
} */

body {
  font-family: Inter, sans-serif;
  position: relative;
}

p {
  margin: 0;
  padding: 0;
}

header {
  box-shadow: 0 4px 20px 0 #00000005;
  background: #fff;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  nav {
    .navbar-brand {
      margin-right: 60px;

      img {
        max-width: 150px;
        padding: 5px 0;
      }
    }

    .navbar-nav {
      .nav-link {
        padding: 10px 9px !important;

        a.link {
          font-family: Lato, sans-serif;
          text-decoration: none;
          color: #000;
          font-weight: 600;
          padding-bottom: 5px;
          font-size: 15px;

          &:hover {
            text-decoration: none;
            padding-bottom: 5px;

            &::after {
              width: 100%;
              transition: width 0.3s;
            }
          }

          &::after {
            content: "";
            display: block;
            width: 0;
            height: 2px;
            background: #fff;
            transition: width 0.3s;
          }

          i {
            font-size: 12px;
          }
        }

        &:hover .submenu {
          display: block !important;
        }
      }

      .submenu {
        &:hover {
          display: block;
        }

        position: absolute;
        background-color: #fff;
        padding: 0;
        box-shadow: 0 15px 20px #0c2e5136;
        display: none;
        z-index: 999999;

        .nav-link {
          font-size: 14px;
          padding: 10px 15px !important;
          border-bottom: 2px solid #0000001c;
          color: #0000008c;
          font-weight: 600;

          a {
            font-family: Lato, sans-serif;
            text-decoration: none;
            color: #000000ab;
            font-weight: 600;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}

.custom-toggler .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
}

.custom-toggler.navbar-toggler {
  border-color: #fff !important;
}

.limitcon {
  position: relative;
  padding-bottom: 40px !important;
  color: #666;
  font-family: Jost, sans-serif;
  height: 200px;
  overflow: hidden;
  transition: 0.2s;
}

.full-height {
  height: 100%;
  transition: 0.2s;
}

.col-md-10 {
  width: 100%;
}

.readmore {
  position: absolute;
  bottom: 0;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  color: #000;
  width: 100%;
  cursor: pointer;
  background-image: linear-gradient(#ffffff73, #fff);
  padding: 10px 0;
  text-align: center;
  left: 0;

  &:hover {
    text-decoration: none;
  }
}

.hidden {
  display: none;
}

.top-header {
  background: #fff;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  .container {
    padding-top: 10px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
  }

  p {
    font-size: 13px;
    font-family: Lato, sans-serif;
    margin: 0;
    display: flex;
    color: #000;
    align-items: center;
    letter-spacing: 0.35px;

    i {
      color: #000;
      padding: 0 10px;
      font-size: 14px;
    }
  }
}

.main-slider {
  z-index: 9;
  padding: 8% 0 5%;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  h2 {
    text-align: center;
    color: #fff;
    font-size: 60px;
    font-weight: 200;
  }

  p {
    font-family: second-font;
    text-align: center;
    color: #fff;
    font-weight: 800;
  }

  .item {
    padding-top: 40px;
    border-radius: 20px 20px 0 0;
  }
}

.form {
  display: flex;
  box-shadow: 4px 7px 20px 6px #0000000a;
  border-radius: 0 0 20px 20px;
  justify-content: center;
  margin-top: 100px;
  background: #ffffff;

  .form-group {
    min-width: 181px;
    margin-bottom: 0;

    select {
      border: 0;
      min-height: 50px;
      padding: 5px 20px;
      border-radius: 0;
    }

    input {
      border: 0;
      min-height: 50px;
      padding: 5px 20px;
      display: block;
      border-radius: 0;
    }

    button {
      display: block;
      min-height: 50px;
      font-weight: 600;
      padding: 10px 30px;
      background-color: #000;
      letter-spacing: 0.5px;
      border-radius: 0;
      margin-left: 0;
    }

    label {
      font-weight: 700 !important;
      color: #fff;
    }
  }
}

.breadcrumb_im {
  padding: 45px 0;
  background-attachment: fixed;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;

  h1 {
    color: #fff;
  }

  span {
    color: #fff;
  }
}

.client_slider {
  display: flex;
  padding: 60px 0 30px;

  .owl-carousel {
    display: flex;

    .item {
      img {
        padding: 36px;
        filter: grayscale(0);
        opacity: 1;
        transition: 1s;

        &:hover {
          filter: grayscale(100%);
          transition: 1s;
        }
      }
    }
  }
}

.listing-home {
  .custom-nav-mobi {
    display: none;
  }

  .custom-nav {
    text-align: center;

    .owl-prev {
      border: 0;
      color: white;
      background-color: #2067d1;
      padding: 0 25px 10px;
      font-size: 35px;
      border-radius: 100%;
    }

    .owl-next {
      border: 0;
      color: white;
      background-color: #2067d1;
      font-size: 35px;
      padding: 0 25px 10px;
      border-radius: 100%;
    }
  }

  .headline {
    display: flex;
    justify-content: space-between;

    .h3 {
      font-family: Lato, sans-serif;
      font-size: 36px;
      font-weight: 700;
      color: #000;
      margin-left: 45px;
    }

    .head_p {
      font-family: Lato, sans-serif;
      font-size: 18px;
      color: #77808b;
      padding-bottom: 15px;
    }
  }

  .listing-slide {
    .card-im {
      border-radius: 20px;
      width: 389px;
      margin: auto;
      max-width: 100%;
      background-color: #f7f7f7;

      .list_headline_two {
        font-family: Jost, sans-serif;
        font-size: 25px;
        font-weight: 700;
        line-height: 30px;
        color: #000;
        margin: 0;
        padding: 20px 0 0;
      }

      .details {
        font-family: Jost, sans-serif;
        font-size: 14px;
        font-weight: 700;
        margin: 0;
        padding: 0 0 5px;
        display: flex;
        justify-content: space-between;

        i {
          color: #2067d1;
        }
      }

      .location_im {
        color: #282c35ad;
        font-weight: 700;
        font-size: 12px;
        padding: 5px 0 20px;
        margin: 0;

        i {
          font-size: 12px;
        }
      }

      .list-footer {
        display: flex;
        align-items: center;
        margin: 15px 0 10px;
        justify-content: space-between;

        .price {
          margin: 0;
          font-size: 15px;
          font-weight: 600;

          i {
            font-size: 15px;
          }

          b {
            font-size: 17px;
            font-weight: 700;
          }
        }
      }
    }

    .theme-btn {
      font-family: Jost, sans-serif;
      border-radius: 5px;
      padding: 5px 10px;
      font-weight: 600;
      color: #fff !important;
      font-size: 12px;
      background-color: #2067d1;
      border: 2px solid #2067d1;
      text-decoration: none;
      display: block;
      width: fit-content;
      margin-top: 0;
      text-transform: uppercase;
    }
  }
}

.about-us {
  padding: 10px 0;

  .row {
    align-items: center;
  }

  .headline {
    .h3 {
      font-family: Lato, sans-serif;
      font-size: 46px;
      font-weight: 700;
      color: #000;
    }

    .sub-headline {
      text-transform: uppercase;
      margin: 0;
      font-weight: 600;
      color: #2067d1;
    }
  }

  .content {
    .p_n {
      font-family: second-font;
      font-size: 16px;
      color: #77808b;
      letter-spacing: 0.2px;
    }
  }
}

.weWork {
  .headline {
    .h3 {
      font-family: Lato, sans-serif;
      font-size: 46px;
      text-align: center;
      font-weight: 700;
      color: #000;
    }

    .sub-headline {
      text-transform: uppercase;
      margin: 0;
      font-weight: 600;
      text-align: center;
      color: #2067d1;
    }
  }

  .weWorkInner {
    display: flex;
    justify-content: space-around;

    .item {
      flex-basis: 16.66%;
      text-align: center;

      .title {
        text-transform: uppercase;
        font-weight: 700;
        padding: 10px;
        margin: 0;
        font-size: 18px;
      }

      &:hover {
        .img-ic {
          background-color: #2267d2;
          transition: 0.3s;

          img {
            transition: 0.3s;
            filter: invert(1);
            transform: scale(1.3);
          }
        }
      }

      .img-ic {
        padding: 25px;
        border: 7px solid #2267d2;
        border-radius: 100%;
        width: 120px;
        transition: 0.3s;
        margin: auto;
        height: 120px;
      }
    }
  }
}

.home-blog {
  .headline {
    .h3 {
      font-family: Lato, sans-serif;
      font-size: 46px;
      text-align: center;
      font-weight: 700;
      color: #000;
    }

    .sub-headline {
      text-transform: uppercase;
      margin: 0;
      font-weight: 600;
      text-align: center;
      color: #2067d1;
    }
  }

  .blog {
    .item {
      padding: 20px;

      .title {
        font-family: Jost, sans-serif;
        font-size: 18px;
        font-weight: 700;
        line-height: 22px;
        color: #000;
        margin: 0;
        padding: 20px 0 5px;
      }
    }

    small {
      color: #89909a;
      font-weight: 600;
      margin-bottom: 10px;
      display: block;
    }

    .des {
      font-family: Jost, sans-serif;
      font-size: 14px;
      color: #77808b;
      letter-spacing: 0.2px;
      line-height: 1.3;
    }
  }
}

.testimonial {
  padding: 60px 0;

  .headline {
    .h3 {
      font-family: Lato, sans-serif;
      font-size: 46px;
      font-weight: 700;
      text-align: center;
      color: #000;
    }

    .sub-headline {
      text-transform: uppercase;
      margin: 0;
      text-align: center;
      font-weight: 600;
      color: #2067d1;
    }
  }

  .client-slide {
    display: flex;

    .item {
      margin: 1px 15px;
      background-color: #fff;
      box-shadow: 5px 8px 26px 6px #00000008;
      border-bottom: 7px solid #fff0;

      p.normal {
        font-weight: 500;
        font-size: 12px;
        letter-spacing: 0.2px;
      }

      p.project {
        font-size: 12px;
        margin: 0;
        font-weight: 900;
        padding: 0;
      }

      .checked {
        color: #fff;
        background-color: #2067d1;
        font-size: 8px;
        padding: 5px;
        margin-bottom: 10px;
      }

      .title {
        font-size: 16px;
        padding-bottom: 5px;
        margin: 0;
      }

      &:hover {
        border-bottom: 7px solid #2067d1;
      }
    }
  }
}

.mail-section {
  .container {
    background-size: cover;
    display: flex;
    justify-content: end;
    align-items: center;
    min-height: 545px;

    .headline {
      margin-right: 13%;
      margin-bottom: -1.2%;

      .h3 {
        font-family: Lato, sans-serif;
        font-size: 46px;
        font-weight: 700;
        color: #000;
        margin: 0;
      }

      .sub-headline {
        text-transform: uppercase;
        margin: 0;
        font-weight: 700;
        color: #000;
        font-size: 17px;
        padding-bottom: 10px;
      }

      input {
        border-radius: 10px;
        font-size: 13px;
        margin-bottom: 12px;
        background-color: #ffffffb8;
        min-height: 40px;
      }

      button {
        margin-top: 10;
        font-size: 12px;
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 500;
        border-radius: 10px;
      }

      .btn-dark {
        background-color: #000;
        border-radius: 8px;
        color: #fff;
      }
    }
  }
}

.main-con {
  .content {
    padding: 20px 0;

    .row {
      align-items: center;
    }

    .h1 {
      font-family: Jost, sans-serif;
      font-size: 35px;
      font-weight: 700;
      color: #000;

      span {
        color: #2067d1;
      }
    }

    .h2 {
      font-family: Jost, sans-serif;
      font-size: 30px;
      font-weight: 700;
      color: #000;

      span {
        color: #2067d1;
      }
    }

    .h3 {
      font-family: Lato, sans-serif;
      font-size: 25px;
      font-weight: 700;
      color: #000;

      span {
        color: #2067d1;
      }
    }

    .p_n {
      font-family: Inter, sans-serif;
      font-size: 16px;
      color: #3f3f3f;
      /* letter-spacing: 0.2px; */
    }
  }
}

footer {
  .top-footer {
    padding: 100px 0;
    background-color: #121212;

    .footer-logo {
      max-width: 200px;
      padding: 15px 0;
    }

    p.normal {
      font-family: Jost, sans-serif;
      font-size: 16px;
      color: #fff;
      letter-spacing: 0.2px;
    }

    .headline {
      font-family: Jost, sans-serif;
      font-size: 26px;
      color: #fff;
      font-weight: 600;
      margin-bottom: 30px;
      letter-spacing: 1px;
    }

    li {
      font-family: Lato, sans-serif;
      list-style: none;
      font-size: 14px;
      font-weight: 600;
      color: #ececec;
      line-height: 2.6;

      &.add {
        line-height: 30px;
        color: #ffffffb8;
        font-weight: 400;
        padding: 0 0 12px;
      }

      &.subhead {
        font-size: 12px;
        text-transform: uppercase;
        line-height: 0;
        padding: 0 0 5px;
      }

      .fa-phone {
        transform: rotate(90deg);
      }

      &.blog-footer {
        line-height: 1.6;
        margin-bottom: 20px;

        small {
          color: #ffffff8a;
        }
      }

      a {
        color: #ececec;
        text-decoration: none;
        font-family: Lato, sans-serif;

        &:hover {
          color: #2067d1;
        }
      }
    }

    .social-links {
      display: flex;
      margin-top: 10px;

      a {
        color: #fff;
      }

      i {
        font-size: 30px;
        padding-right: 15px;
      }
    }
  }

  .bottom-footer {
    background-color: #121212;

    .container {
      justify-content: center;
      display: flex;
      border-top: 1px solid #fff;
      padding: 10px 0;
    }

    p {
      font-family: Lato, sans-serif;
      list-style: none;
      font-size: 14px;
      font-weight: 600;
      color: #fff;
      line-height: 2.6;
      margin: 0;

      a {
        color: #fff;
        text-decoration: none;

        &:hover {
          color: #2067d1;
        }
      }
    }
  }
}

@media (width <= 1200px) and (width >= 676px) {
  header nav .navbar-nav .nav-link a.link {
    font-size: 12px;
  }
 
}

@media (width <= 1080px) and (width >= 676px) {
  .form-top-home {
    .container {
      position: static;
      transform: translate(0, 0);
    }

    .form {
      display: block;

      .form-group {
        margin-right: 0;
      }
    }
  }
}

@media (width <= 676px) {
  .about-us {
    & .headline {
  .sub-headline {
    text-transform: uppercase;
    margin: 0;
    font-weight: 600;
    color: #2067d1;
    text-align: center;
  }
}
  }

  .about-us {
    & .headline {
  h3 {
    text-transform: uppercase;
    margin: 0;
    font-weight: 600;
    color: black;
    text-align: center;
  }
}}

.theme-btn {
  margin: auto;
}

.CTA .callnow {
  background-color: #2067d1;
  color: #fff;
  font-size: 16px;
  padding: 6px 28px;
  flex-basis: 50%;
  justify-content: center;
  display: flex;
  align-items: center;
}

.CTA .whatsapp {
    background-color: #058735;
    color: #fff;
    padding: 6px 28px;
    flex-basis: 50%;
    font-size: 16px;
    align-items: center;
    justify-content: center;
    display: flex
;
}

.CTA .whatsapp a,.CTA .callnow a{
  font-size: 18px;
  color: white;
}

.CTA {
    display: flex;
    position: fixed;
    z-index: 999;
    bottom: 0;
    width: 100%;
}

  .main-slider h2 {
    font-size: 40px;
  }

  .border-r {
    border-radius: 0 0 10px 10px !important;
  }

  .form-top-home {
    .form {
      .form-group {
        input[type="text"] {
          width: 100%;
          padding: 5px 15px;
        }

        select {
          padding: 5px 10px;
        }

        button {
          margin: auto;
          margin-top: 10px;
          min-height: 40px;
          display: block;
          border-radius: 0 0 10px 10px;
          width: auto;
        }
      }

      .form-group {
        &:last-child select {
          border-radius: 0 0 10px 10px;
        }
      }
    }
  }

  .contactUs {
    .contactUsinner {
      padding: 31px !important;
    }
  }

  .top-header {
    .container {
      display: block;
      text-align: center;

      p {
        justify-content: center;
        font-family: second-font;

        &:last-child {
          display: none;
        }
      }
    }
  }

  header nav .navbar-nav .nav-link {
    padding: 11px 20px !important;
    border-bottom: 1px solid #c5c5c5;
  }

  .form-top-home {
    .container {
      position: static;
      transform: translate(0, 0);
    }

    .form {
      display: block;
      margin-right: 0;
    }
  }

  .listing-home {
    .headline {
      .h3 {
        font-family: Lato, sans-serif;
        text-align: center;
        font-size: 28px;
      }

      .head_p {
        text-align: center;
        font-size: 16px;
      }
    }

    .custom-nav-mobi {
      display: block;
      text-align: center;

      .owl-prev {
        border: 0;
        padding: 0 25px 10px;
        font-size: 35px;
        border-radius: 100%;
      }

      .owl-next {
        border: 0;
        font-size: 35px;
        padding: 0 25px 10px;
        border-radius: 100%;
      }
    }

    .listing-slide {
      .card-im {
        border-radius: 15px;
        width: 330px;
        max-width: 100%;
        background-color: #f7f7f7;
        padding: 15px;

        .details {
          span {
            display: block;
          }
        }

        .fa-arrow-right {
          display: none;
        }

        .location_im {
          padding: 10px 0;
          font-size: 13px;
        }
      }
    }
  }

  .mail-section {
    .container {
      background-repeat: no-repeat;
      display: block;

      .headline {
        margin-right: 0;
        margin-bottom: 0;
      }
    }
  }

  .weWork {
    .headline {
      .h3 {
        font-family: Lato, sans-serif;
        font-size: 28px;
      }
    }

    .weWorkInner {
      flex-wrap: wrap;

      .item {
        flex-basis: 50%;
      }
    }
  }

  .testimonial {
    .headline {
      .h3 {
        font-family: Lato, sans-serif;
        font-size: 28px;
      }
    }
  }

  .home-blog {
    .headline {
      .h3 {
        font-family: Lato, sans-serif;
        font-size: 28px;
      }
    }
  }

  footer {
    .top-footer {
      padding: 30px 0;

      .footer-logo {
        margin: auto;
        display: block;
      }

      .normal {
        text-align: center;
      }

      .social-links {
        justify-content: center;
      }

      .headline {
        text-align: center;
        border-top: 1px solid #00000026;
        padding-top: 20px;
        margin-bottom: 5px;
      }

      li {
        text-align: center;

        &:last-child {
          padding-bottom: 20px;
        }
      }
    }
  }

  .client_slider {
    display: flex;
    padding: 0;
  }

  .custom-nav {
    display: none;
  }

  .mobiHide {
    display: none;
  }
}

.testimonial {
  .owl-prev {
    width: 15px;
    height: 100px;
    position: absolute;
    top: 35%;
    margin-left: -15px;
    display: block !important;
    border: 0 solid black;
  }

  .owl-next {
    width: 15px;
    height: 100px;
    position: absolute;
    top: 35%;
    right: -15px;
    display: block !important;
    border: 0 solid black;
  }

  .owl-prev span,
  .owl-next span {
    color: #000;
    font-weight: 600;
    font-size: 40px;
  }
}

.call-btn a {
  font-family: Lato, sans-serif;
  border-radius: 10px;
  padding: 11px 28px;
  font-size: 14px;
  font-weight: 600;
  color: #fff !important;
  background-color: #2067d1;
  border: 2px solid #2067d1;
  text-decoration: none;
  margin-left: 20px;

  &:hover {
    border-radius: 10px;
    padding: 11px 28px;
    border: 2px solid #2067d1;
    font-weight: 600;
    text-decoration: none;
    color: #2067d1 !important;
    background-color: #fff;
  }
}

ul{
  padding: 0;
}

.listing-page {
  .listing-slide {
    .card-im {
      margin-bottom: 30px;
      padding: 25px;

      img {
        object-fit: cover;
        height: 263px;
        border-radius: 24px;
      }

      .location_im {
        min-height: 60px;
      }
    }
  }
}

.details-header {
  padding: 30px 0 0;
  background-color: #fcfdfe;

  .row {
    align-items: center;

    .col-md-6:last-child {
      text-align: right;
    }
  }

  .bubble {
    background-color: #2067d1;
    text-transform: uppercase;
    font-size: 11px;
    padding: 3px 7px;
    color: #fff;
    margin-right: 10px;
  }

  p {
    margin: 0;
  }

  hr {
    margin: 20px 0 0 !important;
  }

  .name {
    font-size: 40px;
    font-weight: 600;
  }

  .dev {
    a {
      color: #2067d1;
      text-decoration: none;

      &:hover {
        color: #2067d1;
        text-decoration: none;
      }
    }
  }

  .address {
    padding-top: 15px;
    color: #6e7079;
    font-size: 14px;
    font-weight: 500;
  }

  .price {
    font-size: 30px;
    font-weight: 600;

    span {
      font-size: 18px;
    }
  }

  .emi-link {
    a {
      color: #2067d1;
      text-decoration: none;
      font-weight: 500;

      &:hover {
        color: #2067d1;
        text-decoration: none;
      }
    }
  }
}

.details-gallery {
  background-color: #fcfdfe;

  .row {
    padding: 0;

    .col-md-6 {
      padding: 0;

      img {
        width: 760px;
        height: 500px;
      }
    }

    .col-md-3 {
      padding: 0;
    }

    img {
      width: 380px;
      height: 250px;
      object-fit: cover;
    }
  }
}

.details-content {
  background-color: #fcfdfe;
  padding: 30px;

  .box {
    background-color: #ffffff3d;
    margin-bottom: 30px;
    border-radius: 6px !important;
    box-shadow: 2px 2px 5px 0 #00000014;
    
    .floor_item {
      width: 350px;
      box-shadow: 0 1px 4px 0 #006ac233;
      margin: 10px;
      padding: 0 20px 20px;
      border-radius: 8px;

      img {
        width: 100%;
      }

      p {
        font-weight: 700;
        color: #000 !important;
        font-size: 18px;
      }

      .btn {
        background-color: #2067d1;
        color: #fff;
        font-weight: 500;
      }
    }

    .calculate {
      padding: 10px;
      margin: 0;

      .calheadline {
        font-weight: 600;
        font-size: 18px;
      }

      p {
        margin: 0;
        padding: 0;
      }
    }
    
    .headline {
      border-bottom: solid 1px #e8e8e8;
      padding: 12px 16px;
      font-size: 15px;
      background-color: #2067d1;
      text-transform: uppercase;
      letter-spacing: 0.2px;
      font-weight: 700;
      color: #fff;
      border-radius: 6px 6px 0 0;
    }

    .inner-item {
      padding: 10px 20px;

      .over_head {
        img {
          border: 1px solid #727272;
          margin-right: 10px;
        }

        display: flex;
        align-items: center;

        p {
          margin: 0;
        }
      }

      p {
        color: #666;
        font-family: second-font;
      }

      p.icon {
        padding: 10px;
        color: #2067d1;

        i {
          font-size: 20px;
        }
      }

      .amenities {
        color: #000;
        line-height: 18px;
      }
     
    }
  }

  .amenities {
    li {
      list-style: none;

      img {
        width: 35px;
        margin-right: 10px;
      }
    }

    .amenities-item {
      padding: 10px;
      display: flex;
      align-items: center;
    }
  }

  .item-fq {
    margin-bottom: 12px;

    .accordion {
      border: 0;
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      text-align: left;
      font-family: Lato, sans-serif;
      padding: 7px 12px;
    }
    
  }
}

.right-sti {
  position: sticky;
  top: 67px;
}

.details-form {
  background-color: #fff;
  padding: 20px;
  box-shadow: 2px 2px 5px 0 #00000014;
  border-radius: 6px !important;
  margin-bottom: 30px;

  .form-control {
    margin-bottom: 15px;
    border-radius: 4px;
    height: 40px;
  }

  .theme-btn {
    border-radius: 4px;
    height: 40px;
    padding: 5px 20px;
    font-size: 14px;
    width: 100%;
  }

  .form-headline {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
  }

  .phone_num {
    select {
      border-radius: 4px 0 0 4px;
      width: 25%;
      border-right: 0;
    }

    input {
      border-radius: 0 4px 4px 0;
    }
  }
}


.tab {
  overflow: hidden;

  .tablinks {
    font-weight: 500;

    i {
      font-size: 12px;
      color: #000;
    }
  }
}

.tab button {
  background-color: #fff0;
  float: left;
  border: 0;
  outline: 0;
  cursor: pointer;
  padding: 4px 16px;
  transition: 0.3s;
  font-size: 17px;
  border-bottom: 4px solid #000;
}

.tab button:hover {
  background-color: #fff0;
}

.tab button.active {
  background-color: #fff0;
  color: #2067d1;
  font-weight: 700;
  border-bottom: 4px solid #2067d1;
}

.tab button.active i {
  color: #000;
}

.tabcontent {
  display: none;
  margin-top: 0;
  padding: 6px 0;
  border-top: 0;

  .tab_price {
    display: flex;
    padding: 10px 10px 0;
    justify-content: space-between;

    p {
      margin-bottom: 7px;
      font-family: second-font;
    }
  }

  .tabf {
    overflow: hidden;
    border-bottom: 1px solid #ccc;
  }

  .tabf button {
    background-color: inherit;
    float: left;
    border: 0;
    outline: 0;
    cursor: pointer;
    padding: 4px 16px;
    transition: 0.3s;
    font-size: 14px;
  }

  .tabf button.activef {
    background-color: #fbfbfb;
    font-weight: 700;
  }

  .tabcontentf {
    display: none;
    padding: 6px 12px;
    border-top: 0;

    .tab_price {
      display: flex;
      padding: 10px 10px 0;
      justify-content: space-between;

      p {
        margin-bottom: 7px;
        font-family: second-font;
      }
    }
  }
}

.accordion {
  background-color: #eee;
  color: #444;
  cursor: pointer;
  margin-top: 20px;
  width: 100%;
  border: 0;
  text-align: left;
  outline: 0;
  font-size: 15px;
  transition: 0.4s;
  border-radius: 5px;
  padding: 5px 30px;
}

.active .accordion:hover {
  background-color: #ccc;
}

.faqs {
  .p_n {
    margin-bottom: 4px;
    font-size: 14px !important;
    display: list-item;
    list-style: disc inside;
  }

  .row {
    align-items: baseline !important;
  }
}

.contactUs {
  .h1 {
    padding: 0 0 25px;
    text-align: center;
  }

  .container {
    margin-top: -100px;
  }

  .contactUsinner {
    padding: 80px 120px;
    background-color: white;
    position: relative;
    box-shadow: 0 10px 50px #00000012;
    margin: 0 auto 50px;

    label {
      padding: 15px 0 0;
      margin: 0;
      font-size: 13px;
      font-weight: 500;
      letter-spacing: 0.5px;
    }

    .form-control {
      border-radius: 8px;
      min-height: 45px;
    }

    .form {
      max-width: 900px;
      margin: auto;
    }
   
    .cont_details {
      align-items: center;
      display: flex;
      margin-bottom: 30px;

      .mobile {
        font-size: 20px;
      }

      i {
        font-size: 30px;
        color: #2067d1;
        padding-right: 15px;
      }

      p {
        margin: 0;
        font-weight: 600;
        font-family: Jost, sans-serif;
      }

      .blueBox {
        background-color: #2067d1;
        display: flex;
        padding: 18px 32px;
        color: #fff;
        align-items: center;
        border-radius: 30px;

        i {
          color: #fff;
          font-size: 40px;
        }
      }
    }
  }
}

#ScrollTop {
  display: none;
  position: fixed;
  bottom: 90px;
  right: 15px;
  z-index: 99;
  font-size: 12px;
  outline: 0;
  border: 0;
  background-color: #2067d1;
  color: white;
  cursor: pointer;
  padding: 16px 20px;
  border-radius: 50%;
  box-shadow: 0 0 15px 0 #00000045;
}

#ScrollTop:hover {
  background-color: #555;
}


@media (width >= 1200px) {
  .container, .container-lg, .container-md, .container-sm, .container-xl {
      max-width: 1400px;
  }
}

.swiper{
  padding: 26px !important;
}

.iticks-pop-button {
  background: #0565f1!important;
}

.CTA{
display: none;
}

@media screen and (width <= 768px) {
  .CTA {
      display: flex; 
  }
}

.aRemove {
  color: #000;
}

a:hover{
  text-decoration: none;
  text-underline-offset: none;
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.5em + .75rem + 2px);
  padding: .375rem 1.75rem .375rem .75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  vertical-align: middle;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  appearance: none;
}

.table-bordered{
  border: 1px solid #dee2e6;
}

.table>tbody {
  border: 1px solid #dee2e6;
}

.table-bordered td {
  font-weight: 600;
  color: #14191e;
  padding: .75rem;
  vertical-align: top;
}

.table-bordered th{
  font-weight: 400;
  color: #212529;
  padding: .75rem;
  vertical-align: top;
}`, "",{"version":3,"sources":["webpack://./src/app/components/styles/css/style.css"],"names":[],"mappings":"AAGA;;;;;;;GAOG;;AAEH;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;;EAE5B;IACE;MACE,kBAAkB;;MAElB;QACE,gBAAgB;QAChB,cAAc;MAChB;IACF;;IAEA;MACE;QACE,4BAA4B;;QAE5B;UACE,6BAA6B;UAC7B,qBAAqB;UACrB,WAAW;UACX,gBAAgB;UAChB,mBAAmB;UACnB,eAAe;;UAEf;YACE,qBAAqB;YACrB,mBAAmB;;YAEnB;cACE,WAAW;cACX,sBAAsB;YACxB;UACF;;UAEA;YACE,WAAW;YACX,cAAc;YACd,QAAQ;YACR,WAAW;YACX,gBAAgB;YAChB,sBAAsB;UACxB;;UAEA;YACE,eAAe;UACjB;QACF;;QAEA;UACE,yBAAyB;QAC3B;MACF;;MAEA;QACE;UACE,cAAc;QAChB;;QAEA,kBAAkB;QAClB,sBAAsB;QACtB,UAAU;QACV,iCAAiC;QACjC,aAAa;QACb,eAAe;;QAEf;UACE,eAAe;UACf,6BAA6B;UAC7B,kCAAkC;UAClC,gBAAgB;UAChB,gBAAgB;;UAEhB;YACE,6BAA6B;YAC7B,qBAAqB;YACrB,gBAAgB;YAChB,gBAAgB;YAChB,mBAAmB;UACrB;QACF;MACF;IACF;EACF;AACF;;AAEA;EACE,oEAAkQ;AACpQ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,WAAW;EACX,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,WAAW;EACX,eAAe;EACf,kDAAkD;EAClD,eAAe;EACf,kBAAkB;EAClB,OAAO;;EAEP;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;;EAE5B;IACE,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,6BAA6B;IAC7B,SAAS;IACT,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,sBAAsB;;IAEtB;MACE,WAAW;MACX,eAAe;MACf,eAAe;IACjB;EACF;AACF;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;;EAE5B;IACE,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,4BAA4B;EAC9B;AACF;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;;EAEnB;IACE,gBAAgB;IAChB,gBAAgB;;IAEhB;MACE,SAAS;MACT,gBAAgB;MAChB,iBAAiB;MACjB,gBAAgB;IAClB;;IAEA;MACE,SAAS;MACT,gBAAgB;MAChB,iBAAiB;MACjB,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,gBAAgB;MAChB,kBAAkB;MAClB,sBAAsB;MACtB,qBAAqB;MACrB,gBAAgB;MAChB,cAAc;IAChB;;IAEA;MACE,2BAA2B;MAC3B,WAAW;IACb;EACF;AACF;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,2BAA2B;EAC3B,sBAAsB;EACtB,4BAA4B;;EAE5B;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,oBAAoB;;EAEpB;IACE,aAAa;;IAEb;MACE;QACE,aAAa;QACb,oBAAoB;QACpB,UAAU;QACV,cAAc;;QAEd;UACE,uBAAuB;UACvB,cAAc;QAChB;MACF;IACF;EACF;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;;IAElB;MACE,SAAS;MACT,YAAY;MACZ,yBAAyB;MACzB,oBAAoB;MACpB,eAAe;MACf,mBAAmB;IACrB;;IAEA;MACE,SAAS;MACT,YAAY;MACZ,yBAAyB;MACzB,eAAe;MACf,oBAAoB;MACpB,mBAAmB;IACrB;EACF;;EAEA;IACE,aAAa;IACb,8BAA8B;;IAE9B;MACE,6BAA6B;MAC7B,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,iBAAiB;IACnB;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,cAAc;MACd,oBAAoB;IACtB;EACF;;EAEA;IACE;MACE,mBAAmB;MACnB,YAAY;MACZ,YAAY;MACZ,eAAe;MACf,yBAAyB;;MAEzB;QACE,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;QACX,SAAS;QACT,iBAAiB;MACnB;;MAEA;QACE,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,SAAS;QACT,gBAAgB;QAChB,aAAa;QACb,8BAA8B;;QAE9B;UACE,cAAc;QAChB;MACF;;MAEA;QACE,gBAAgB;QAChB,gBAAgB;QAChB,eAAe;QACf,mBAAmB;QACnB,SAAS;;QAET;UACE,eAAe;QACjB;MACF;;MAEA;QACE,aAAa;QACb,mBAAmB;QACnB,mBAAmB;QACnB,8BAA8B;;QAE9B;UACE,SAAS;UACT,eAAe;UACf,gBAAgB;;UAEhB;YACE,eAAe;UACjB;;UAEA;YACE,eAAe;YACf,gBAAgB;UAClB;QACF;MACF;IACF;;IAEA;MACE,6BAA6B;MAC7B,kBAAkB;MAClB,iBAAiB;MACjB,gBAAgB;MAChB,sBAAsB;MACtB,eAAe;MACf,yBAAyB;MACzB,yBAAyB;MACzB,qBAAqB;MACrB,cAAc;MACd,kBAAkB;MAClB,aAAa;MACb,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE,eAAe;;EAEf;IACE,mBAAmB;EACrB;;EAEA;IACE;MACE,6BAA6B;MAC7B,eAAe;MACf,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,yBAAyB;MACzB,SAAS;MACT,gBAAgB;MAChB,cAAc;IAChB;EACF;;EAEA;IACE;MACE,wBAAwB;MACxB,eAAe;MACf,cAAc;MACd,qBAAqB;IACvB;EACF;AACF;;AAEA;EACE;IACE;MACE,6BAA6B;MAC7B,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,yBAAyB;MACzB,SAAS;MACT,gBAAgB;MAChB,kBAAkB;MAClB,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;IACb,6BAA6B;;IAE7B;MACE,kBAAkB;MAClB,kBAAkB;;MAElB;QACE,yBAAyB;QACzB,gBAAgB;QAChB,aAAa;QACb,SAAS;QACT,eAAe;MACjB;;MAEA;QACE;UACE,yBAAyB;UACzB,gBAAgB;;UAEhB;YACE,gBAAgB;YAChB,iBAAiB;YACjB,qBAAqB;UACvB;QACF;MACF;;MAEA;QACE,aAAa;QACb,yBAAyB;QACzB,mBAAmB;QACnB,YAAY;QACZ,gBAAgB;QAChB,YAAY;QACZ,aAAa;MACf;IACF;EACF;AACF;;AAEA;EACE;IACE;MACE,6BAA6B;MAC7B,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;IACb;;IAEA;MACE,yBAAyB;MACzB,SAAS;MACT,gBAAgB;MAChB,kBAAkB;MAClB,cAAc;IAChB;EACF;;EAEA;IACE;MACE,aAAa;;MAEb;QACE,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,iBAAiB;QACjB,WAAW;QACX,SAAS;QACT,mBAAmB;MACrB;IACF;;IAEA;MACE,cAAc;MACd,gBAAgB;MAChB,mBAAmB;MACnB,cAAc;IAChB;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,cAAc;MACd,qBAAqB;MACrB,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,eAAe;;EAEf;IACE;MACE,6BAA6B;MAC7B,eAAe;MACf,gBAAgB;MAChB,kBAAkB;MAClB,WAAW;IACb;;IAEA;MACE,yBAAyB;MACzB,SAAS;MACT,kBAAkB;MAClB,gBAAgB;MAChB,cAAc;IAChB;EACF;;EAEA;IACE,aAAa;;IAEb;MACE,gBAAgB;MAChB,sBAAsB;MACtB,sCAAsC;MACtC,8BAA8B;;MAE9B;QACE,gBAAgB;QAChB,eAAe;QACf,qBAAqB;MACvB;;MAEA;QACE,eAAe;QACf,SAAS;QACT,gBAAgB;QAChB,UAAU;MACZ;;MAEA;QACE,WAAW;QACX,yBAAyB;QACzB,cAAc;QACd,YAAY;QACZ,mBAAmB;MACrB;;MAEA;QACE,eAAe;QACf,mBAAmB;QACnB,SAAS;MACX;;MAEA;QACE,gCAAgC;MAClC;IACF;EACF;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;IACb,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;;IAEjB;MACE,iBAAiB;MACjB,oBAAoB;;MAEpB;QACE,6BAA6B;QAC7B,eAAe;QACf,gBAAgB;QAChB,WAAW;QACX,SAAS;MACX;;MAEA;QACE,yBAAyB;QACzB,SAAS;QACT,gBAAgB;QAChB,WAAW;QACX,eAAe;QACf,oBAAoB;MACtB;;MAEA;QACE,mBAAmB;QACnB,eAAe;QACf,mBAAmB;QACnB,2BAA2B;QAC3B,gBAAgB;MAClB;;MAEA;QACE,cAAc;QACd,eAAe;QACf,yBAAyB;QACzB,mBAAmB;QACnB,gBAAgB;QAChB,mBAAmB;MACrB;;MAEA;QACE,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;MACb;IACF;EACF;AACF;;AAEA;EACE;IACE,eAAe;;IAEf;MACE,mBAAmB;IACrB;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,gBAAgB;MAChB,WAAW;;MAEX;QACE,cAAc;MAChB;IACF;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,gBAAgB;MAChB,WAAW;;MAEX;QACE,cAAc;MAChB;IACF;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,gBAAgB;MAChB,WAAW;;MAEX;QACE,cAAc;MAChB;IACF;;IAEA;MACE,8BAA8B;MAC9B,eAAe;MACf,cAAc;MACd,2BAA2B;IAC7B;EACF;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,yBAAyB;;IAEzB;MACE,gBAAgB;MAChB,eAAe;IACjB;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,WAAW;MACX,qBAAqB;IACvB;;IAEA;MACE,6BAA6B;MAC7B,eAAe;MACf,WAAW;MACX,gBAAgB;MAChB,mBAAmB;MACnB,mBAAmB;IACrB;;IAEA;MACE,6BAA6B;MAC7B,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,cAAc;MACd,gBAAgB;;MAEhB;QACE,iBAAiB;QACjB,gBAAgB;QAChB,gBAAgB;QAChB,iBAAiB;MACnB;;MAEA;QACE,eAAe;QACf,yBAAyB;QACzB,cAAc;QACd,gBAAgB;MAClB;;MAEA;QACE,wBAAwB;MAC1B;;MAEA;QACE,gBAAgB;QAChB,mBAAmB;;QAEnB;UACE,gBAAgB;QAClB;MACF;;MAEA;QACE,cAAc;QACd,qBAAqB;QACrB,6BAA6B;;QAE7B;UACE,cAAc;QAChB;MACF;IACF;;IAEA;MACE,aAAa;MACb,gBAAgB;;MAEhB;QACE,WAAW;MACb;;MAEA;QACE,eAAe;QACf,mBAAmB;MACrB;IACF;EACF;;EAEA;IACE,yBAAyB;;IAEzB;MACE,uBAAuB;MACvB,aAAa;MACb,0BAA0B;MAC1B,eAAe;IACjB;;IAEA;MACE,6BAA6B;MAC7B,gBAAgB;MAChB,eAAe;MACf,gBAAgB;MAChB,WAAW;MACX,gBAAgB;MAChB,SAAS;;MAET;QACE,WAAW;QACX,qBAAqB;;QAErB;UACE,cAAc;QAChB;MACF;IACF;EACF;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;AAEF;;AAEA;EACE;IACE;MACE,gBAAgB;MAChB,0BAA0B;IAC5B;;IAEA;MACE,cAAc;;MAEd;QACE,eAAe;MACjB;IACF;EACF;AACF;;AAEA;EACE;IACE;EACF;IACE,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,kBAAkB;EACpB;AACF;EACE;;EAEA;IACE;EACF;IACE,yBAAyB;IACzB,SAAS;IACT,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;EACpB;AACF,CAAC;;AAED;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,aAAa;EACb,mBAAmB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,uBAAuB;IACvB;AACJ;AACA;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,SAAS;IACT,WAAW;AACf;;EAEE;IACE,eAAe;EACjB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE;MACE;QACE;UACE,WAAW;UACX,iBAAiB;QACnB;;QAEA;UACE,iBAAiB;QACnB;;QAEA;UACE,YAAY;UACZ,gBAAgB;UAChB,gBAAgB;UAChB,cAAc;UACd,4BAA4B;UAC5B,WAAW;QACb;MACF;;MAEA;QACE;UACE,4BAA4B;QAC9B;MACF;IACF;EACF;;EAEA;IACE;MACE,wBAAwB;IAC1B;EACF;;EAEA;IACE;MACE,cAAc;MACd,kBAAkB;;MAElB;QACE,uBAAuB;QACvB,wBAAwB;;QAExB;UACE,aAAa;QACf;MACF;IACF;EACF;;EAEA;IACE,6BAA6B;IAC7B,gCAAgC;EAClC;;EAEA;IACE;MACE,gBAAgB;MAChB,0BAA0B;IAC5B;;IAEA;MACE,cAAc;MACd,eAAe;IACjB;EACF;;EAEA;IACE;MACE;QACE,6BAA6B;QAC7B,kBAAkB;QAClB,eAAe;MACjB;;MAEA;QACE,kBAAkB;QAClB,eAAe;MACjB;IACF;;IAEA;MACE,cAAc;MACd,kBAAkB;;MAElB;QACE,SAAS;QACT,oBAAoB;QACpB,eAAe;QACf,mBAAmB;MACrB;;MAEA;QACE,SAAS;QACT,eAAe;QACf,oBAAoB;QACpB,mBAAmB;MACrB;IACF;;IAEA;MACE;QACE,mBAAmB;QACnB,YAAY;QACZ,eAAe;QACf,yBAAyB;QACzB,aAAa;;QAEb;UACE;YACE,cAAc;UAChB;QACF;;QAEA;UACE,aAAa;QACf;;QAEA;UACE,eAAe;UACf,eAAe;QACjB;MACF;IACF;EACF;;EAEA;IACE;MACE,4BAA4B;MAC5B,cAAc;;MAEd;QACE,eAAe;QACf,gBAAgB;MAClB;IACF;EACF;;EAEA;IACE;MACE;QACE,6BAA6B;QAC7B,eAAe;MACjB;IACF;;IAEA;MACE,eAAe;;MAEf;QACE,eAAe;MACjB;IACF;EACF;;EAEA;IACE;MACE;QACE,6BAA6B;QAC7B,eAAe;MACjB;IACF;EACF;;EAEA;IACE;MACE;QACE,6BAA6B;QAC7B,eAAe;MACjB;IACF;EACF;;EAEA;IACE;MACE,eAAe;;MAEf;QACE,YAAY;QACZ,cAAc;MAChB;;MAEA;QACE,kBAAkB;MACpB;;MAEA;QACE,uBAAuB;MACzB;;MAEA;QACE,kBAAkB;QAClB,+BAA+B;QAC/B,iBAAiB;QACjB,kBAAkB;MACpB;;MAEA;QACE,kBAAkB;;QAElB;UACE,oBAAoB;QACtB;MACF;IACF;EACF;;EAEA;IACE,aAAa;IACb,UAAU;EACZ;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,kBAAkB;IAClB,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;EACvB;;EAEA;;IAEE,WAAW;IACX,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,iBAAiB;;EAEjB;IACE,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;EACxB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE;MACE,mBAAmB;MACnB,aAAa;;MAEb;QACE,iBAAiB;QACjB,aAAa;QACb,mBAAmB;MACrB;;MAEA;QACE,gBAAgB;MAClB;IACF;EACF;AACF;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;;EAEzB;IACE,mBAAmB;;IAEnB;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE,yBAAyB;IACzB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE;MACE,cAAc;MACd,qBAAqB;;MAErB;QACE,cAAc;QACd,qBAAqB;MACvB;IACF;EACF;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;;IAEhB;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,cAAc;MACd,qBAAqB;MACrB,gBAAgB;;MAEhB;QACE,cAAc;QACd,qBAAqB;MACvB;IACF;EACF;AACF;;AAEA;EACE,yBAAyB;;EAEzB;IACE,UAAU;;IAEV;MACE,UAAU;;MAEV;QACE,YAAY;QACZ,aAAa;MACf;IACF;;IAEA;MACE,UAAU;IACZ;;IAEA;MACE,YAAY;MACZ,aAAa;MACb,iBAAiB;IACnB;EACF;AACF;;AAEA;EACE,yBAAyB;EACzB,aAAa;;EAEb;IACE,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;IAC7B,mCAAmC;;IAEnC;MACE,YAAY;MACZ,iCAAiC;MACjC,YAAY;MACZ,oBAAoB;MACpB,kBAAkB;;MAElB;QACE,WAAW;MACb;;MAEA;QACE,gBAAgB;QAChB,sBAAsB;QACtB,eAAe;MACjB;;MAEA;QACE,yBAAyB;QACzB,WAAW;QACX,gBAAgB;MAClB;IACF;;IAEA;MACE,aAAa;MACb,SAAS;;MAET;QACE,gBAAgB;QAChB,eAAe;MACjB;;MAEA;QACE,SAAS;QACT,UAAU;MACZ;IACF;;IAEA;MACE,gCAAgC;MAChC,kBAAkB;MAClB,eAAe;MACf,yBAAyB;MACzB,yBAAyB;MACzB,qBAAqB;MACrB,gBAAgB;MAChB,WAAW;MACX,0BAA0B;IAC5B;;IAEA;MACE,kBAAkB;;MAElB;QACE;UACE,yBAAyB;UACzB,kBAAkB;QACpB;;QAEA,aAAa;QACb,mBAAmB;;QAEnB;UACE,SAAS;QACX;MACF;;MAEA;QACE,WAAW;QACX,wBAAwB;MAC1B;;MAEA;QACE,aAAa;QACb,cAAc;;QAEd;UACE,eAAe;QACjB;MACF;;MAEA;QACE,WAAW;QACX,iBAAiB;MACnB;;IAEF;EACF;;EAEA;IACE;MACE,gBAAgB;;MAEhB;QACE,WAAW;QACX,kBAAkB;MACpB;IACF;;IAEA;MACE,aAAa;MACb,aAAa;MACb,mBAAmB;IACrB;EACF;;EAEA;IACE,mBAAmB;;IAEnB;MACE,SAAS;MACT,WAAW;MACX,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,gBAAgB;MAChB,6BAA6B;MAC7B,iBAAiB;IACnB;;EAEF;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mCAAmC;EACnC,6BAA6B;EAC7B,mBAAmB;;EAEnB;IACE,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE;MACE,0BAA0B;MAC1B,UAAU;MACV,eAAe;IACjB;;IAEA;MACE,0BAA0B;IAC5B;EACF;AACF;;;AAGA;EACE,gBAAgB;;EAEhB;IACE,gBAAgB;;IAEhB;MACE,eAAe;MACf,WAAW;IACb;EACF;AACF;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,SAAS;EACT,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;EACd,aAAa;;EAEb;IACE,aAAa;IACb,oBAAoB;IACpB,8BAA8B;;IAE9B;MACE,kBAAkB;MAClB,wBAAwB;IAC1B;EACF;;EAEA;IACE,gBAAgB;IAChB,6BAA6B;EAC/B;;EAEA;IACE,yBAAyB;IACzB,WAAW;IACX,SAAS;IACT,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,aAAa;;IAEb;MACE,aAAa;MACb,oBAAoB;MACpB,8BAA8B;;MAE9B;QACE,kBAAkB;QAClB,wBAAwB;MAC1B;IACF;EACF;AACF;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,iCAAiC;IACjC,mBAAmB;;IAEnB;MACE,iBAAiB;MACjB,SAAS;MACT,eAAe;MACf,gBAAgB;MAChB,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;IAClB;;IAEA;MACE,gBAAgB;MAChB,YAAY;IACd;;IAEA;MACE,mBAAmB;MACnB,aAAa;MACb,mBAAmB;;MAEnB;QACE,eAAe;MACjB;;MAEA;QACE,eAAe;QACf,cAAc;QACd,mBAAmB;MACrB;;MAEA;QACE,SAAS;QACT,gBAAgB;QAChB,6BAA6B;MAC/B;;MAEA;QACE,yBAAyB;QACzB,aAAa;QACb,kBAAkB;QAClB,WAAW;QACX,mBAAmB;QACnB,mBAAmB;;QAEnB;UACE,WAAW;UACX,eAAe;QACjB;MACF;IACF;EACF;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,WAAW;EACX,WAAW;EACX,eAAe;EACf,UAAU;EACV,SAAS;EACT,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE;MACI,iBAAiB;EACrB;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;AACA,aAAa;AACb;;AAEA;EACE;MACI,aAAa;EACjB;AACF;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kCAAkC;EAClC,uCAAuC;EACvC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB","sourcesContent":["@import url(\"http://fonts.cdnfonts.com/css/sofia-pro\");\n@import url(\"https://fonts.googleapis.com/css2?family=Jost:wght@300;400;600&display=swap\");\n\n/* @font-face {\n  font-family: \"Inter\";\n  src: url(\"/fonts/font.woff2\") format(\"woff2\"),\n       url(\"/fonts/font.woff\") format(\"woff\");\n  font-weight: normal;\n  font-style: normal;\n  font-display: swap;\n} */\n\nbody {\n  font-family: Inter, sans-serif;\n  position: relative;\n}\n\np {\n  margin: 0;\n  padding: 0;\n}\n\nheader {\n  box-shadow: 0 4px 20px 0 #00000005;\n  background: #fff;\n  background-attachment: fixed;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n\n  nav {\n    .navbar-brand {\n      margin-right: 60px;\n\n      img {\n        max-width: 150px;\n        padding: 5px 0;\n      }\n    }\n\n    .navbar-nav {\n      .nav-link {\n        padding: 10px 9px !important;\n\n        a.link {\n          font-family: Lato, sans-serif;\n          text-decoration: none;\n          color: #000;\n          font-weight: 600;\n          padding-bottom: 5px;\n          font-size: 15px;\n\n          &:hover {\n            text-decoration: none;\n            padding-bottom: 5px;\n\n            &::after {\n              width: 100%;\n              transition: width 0.3s;\n            }\n          }\n\n          &::after {\n            content: \"\";\n            display: block;\n            width: 0;\n            height: 2px;\n            background: #fff;\n            transition: width 0.3s;\n          }\n\n          i {\n            font-size: 12px;\n          }\n        }\n\n        &:hover .submenu {\n          display: block !important;\n        }\n      }\n\n      .submenu {\n        &:hover {\n          display: block;\n        }\n\n        position: absolute;\n        background-color: #fff;\n        padding: 0;\n        box-shadow: 0 15px 20px #0c2e5136;\n        display: none;\n        z-index: 999999;\n\n        .nav-link {\n          font-size: 14px;\n          padding: 10px 15px !important;\n          border-bottom: 2px solid #0000001c;\n          color: #0000008c;\n          font-weight: 600;\n\n          a {\n            font-family: Lato, sans-serif;\n            text-decoration: none;\n            color: #000000ab;\n            font-weight: 600;\n            padding-bottom: 5px;\n          }\n        }\n      }\n    }\n  }\n}\n\n.custom-toggler .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml;charset=utf8,%3CsvgviewBox='003232'xmlns='http://www.w3.org/2000/svg'%3E%3Cpathstroke='rgba(255,255,255)'stroke-width='2'stroke-linecap='round'stroke-miterlimit='10'd='M48h24M416h24M424h24'/%3E%3C/svg%3E\") !important;\n}\n\n.custom-toggler.navbar-toggler {\n  border-color: #fff !important;\n}\n\n.limitcon {\n  position: relative;\n  padding-bottom: 40px !important;\n  color: #666;\n  font-family: Jost, sans-serif;\n  height: 200px;\n  overflow: hidden;\n  transition: 0.2s;\n}\n\n.full-height {\n  height: 100%;\n  transition: 0.2s;\n}\n\n.col-md-10 {\n  width: 100%;\n}\n\n.readmore {\n  position: absolute;\n  bottom: 0;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n  color: #000;\n  width: 100%;\n  cursor: pointer;\n  background-image: linear-gradient(#ffffff73, #fff);\n  padding: 10px 0;\n  text-align: center;\n  left: 0;\n\n  &:hover {\n    text-decoration: none;\n  }\n}\n\n.hidden {\n  display: none;\n}\n\n.top-header {\n  background: #fff;\n  background-attachment: fixed;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n\n  .container {\n    padding-top: 10px;\n    font-weight: 700;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  p {\n    font-size: 13px;\n    font-family: Lato, sans-serif;\n    margin: 0;\n    display: flex;\n    color: #000;\n    align-items: center;\n    letter-spacing: 0.35px;\n\n    i {\n      color: #000;\n      padding: 0 10px;\n      font-size: 14px;\n    }\n  }\n}\n\n.main-slider {\n  z-index: 9;\n  padding: 8% 0 5%;\n  background-attachment: fixed;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n\n  h2 {\n    text-align: center;\n    color: #fff;\n    font-size: 60px;\n    font-weight: 200;\n  }\n\n  p {\n    font-family: second-font;\n    text-align: center;\n    color: #fff;\n    font-weight: 800;\n  }\n\n  .item {\n    padding-top: 40px;\n    border-radius: 20px 20px 0 0;\n  }\n}\n\n.form {\n  display: flex;\n  box-shadow: 4px 7px 20px 6px #0000000a;\n  border-radius: 0 0 20px 20px;\n  justify-content: center;\n  margin-top: 100px;\n  background: #ffffff;\n\n  .form-group {\n    min-width: 181px;\n    margin-bottom: 0;\n\n    select {\n      border: 0;\n      min-height: 50px;\n      padding: 5px 20px;\n      border-radius: 0;\n    }\n\n    input {\n      border: 0;\n      min-height: 50px;\n      padding: 5px 20px;\n      display: block;\n      border-radius: 0;\n    }\n\n    button {\n      display: block;\n      min-height: 50px;\n      font-weight: 600;\n      padding: 10px 30px;\n      background-color: #000;\n      letter-spacing: 0.5px;\n      border-radius: 0;\n      margin-left: 0;\n    }\n\n    label {\n      font-weight: 700 !important;\n      color: #fff;\n    }\n  }\n}\n\n.breadcrumb_im {\n  padding: 45px 0;\n  background-attachment: fixed;\n  background-position: center;\n  background-size: cover;\n  background-repeat: no-repeat;\n\n  h1 {\n    color: #fff;\n  }\n\n  span {\n    color: #fff;\n  }\n}\n\n.client_slider {\n  display: flex;\n  padding: 60px 0 30px;\n\n  .owl-carousel {\n    display: flex;\n\n    .item {\n      img {\n        padding: 36px;\n        filter: grayscale(0);\n        opacity: 1;\n        transition: 1s;\n\n        &:hover {\n          filter: grayscale(100%);\n          transition: 1s;\n        }\n      }\n    }\n  }\n}\n\n.listing-home {\n  .custom-nav-mobi {\n    display: none;\n  }\n\n  .custom-nav {\n    text-align: center;\n\n    .owl-prev {\n      border: 0;\n      color: white;\n      background-color: #2067d1;\n      padding: 0 25px 10px;\n      font-size: 35px;\n      border-radius: 100%;\n    }\n\n    .owl-next {\n      border: 0;\n      color: white;\n      background-color: #2067d1;\n      font-size: 35px;\n      padding: 0 25px 10px;\n      border-radius: 100%;\n    }\n  }\n\n  .headline {\n    display: flex;\n    justify-content: space-between;\n\n    .h3 {\n      font-family: Lato, sans-serif;\n      font-size: 36px;\n      font-weight: 700;\n      color: #000;\n      margin-left: 45px;\n    }\n\n    .head_p {\n      font-family: Lato, sans-serif;\n      font-size: 18px;\n      color: #77808b;\n      padding-bottom: 15px;\n    }\n  }\n\n  .listing-slide {\n    .card-im {\n      border-radius: 20px;\n      width: 389px;\n      margin: auto;\n      max-width: 100%;\n      background-color: #f7f7f7;\n\n      .list_headline_two {\n        font-family: Jost, sans-serif;\n        font-size: 25px;\n        font-weight: 700;\n        line-height: 30px;\n        color: #000;\n        margin: 0;\n        padding: 20px 0 0;\n      }\n\n      .details {\n        font-family: Jost, sans-serif;\n        font-size: 14px;\n        font-weight: 700;\n        margin: 0;\n        padding: 0 0 5px;\n        display: flex;\n        justify-content: space-between;\n\n        i {\n          color: #2067d1;\n        }\n      }\n\n      .location_im {\n        color: #282c35ad;\n        font-weight: 700;\n        font-size: 12px;\n        padding: 5px 0 20px;\n        margin: 0;\n\n        i {\n          font-size: 12px;\n        }\n      }\n\n      .list-footer {\n        display: flex;\n        align-items: center;\n        margin: 15px 0 10px;\n        justify-content: space-between;\n\n        .price {\n          margin: 0;\n          font-size: 15px;\n          font-weight: 600;\n\n          i {\n            font-size: 15px;\n          }\n\n          b {\n            font-size: 17px;\n            font-weight: 700;\n          }\n        }\n      }\n    }\n\n    .theme-btn {\n      font-family: Jost, sans-serif;\n      border-radius: 5px;\n      padding: 5px 10px;\n      font-weight: 600;\n      color: #fff !important;\n      font-size: 12px;\n      background-color: #2067d1;\n      border: 2px solid #2067d1;\n      text-decoration: none;\n      display: block;\n      width: fit-content;\n      margin-top: 0;\n      text-transform: uppercase;\n    }\n  }\n}\n\n.about-us {\n  padding: 10px 0;\n\n  .row {\n    align-items: center;\n  }\n\n  .headline {\n    .h3 {\n      font-family: Lato, sans-serif;\n      font-size: 46px;\n      font-weight: 700;\n      color: #000;\n    }\n\n    .sub-headline {\n      text-transform: uppercase;\n      margin: 0;\n      font-weight: 600;\n      color: #2067d1;\n    }\n  }\n\n  .content {\n    .p_n {\n      font-family: second-font;\n      font-size: 16px;\n      color: #77808b;\n      letter-spacing: 0.2px;\n    }\n  }\n}\n\n.weWork {\n  .headline {\n    .h3 {\n      font-family: Lato, sans-serif;\n      font-size: 46px;\n      text-align: center;\n      font-weight: 700;\n      color: #000;\n    }\n\n    .sub-headline {\n      text-transform: uppercase;\n      margin: 0;\n      font-weight: 600;\n      text-align: center;\n      color: #2067d1;\n    }\n  }\n\n  .weWorkInner {\n    display: flex;\n    justify-content: space-around;\n\n    .item {\n      flex-basis: 16.66%;\n      text-align: center;\n\n      .title {\n        text-transform: uppercase;\n        font-weight: 700;\n        padding: 10px;\n        margin: 0;\n        font-size: 18px;\n      }\n\n      &:hover {\n        .img-ic {\n          background-color: #2267d2;\n          transition: 0.3s;\n\n          img {\n            transition: 0.3s;\n            filter: invert(1);\n            transform: scale(1.3);\n          }\n        }\n      }\n\n      .img-ic {\n        padding: 25px;\n        border: 7px solid #2267d2;\n        border-radius: 100%;\n        width: 120px;\n        transition: 0.3s;\n        margin: auto;\n        height: 120px;\n      }\n    }\n  }\n}\n\n.home-blog {\n  .headline {\n    .h3 {\n      font-family: Lato, sans-serif;\n      font-size: 46px;\n      text-align: center;\n      font-weight: 700;\n      color: #000;\n    }\n\n    .sub-headline {\n      text-transform: uppercase;\n      margin: 0;\n      font-weight: 600;\n      text-align: center;\n      color: #2067d1;\n    }\n  }\n\n  .blog {\n    .item {\n      padding: 20px;\n\n      .title {\n        font-family: Jost, sans-serif;\n        font-size: 18px;\n        font-weight: 700;\n        line-height: 22px;\n        color: #000;\n        margin: 0;\n        padding: 20px 0 5px;\n      }\n    }\n\n    small {\n      color: #89909a;\n      font-weight: 600;\n      margin-bottom: 10px;\n      display: block;\n    }\n\n    .des {\n      font-family: Jost, sans-serif;\n      font-size: 14px;\n      color: #77808b;\n      letter-spacing: 0.2px;\n      line-height: 1.3;\n    }\n  }\n}\n\n.testimonial {\n  padding: 60px 0;\n\n  .headline {\n    .h3 {\n      font-family: Lato, sans-serif;\n      font-size: 46px;\n      font-weight: 700;\n      text-align: center;\n      color: #000;\n    }\n\n    .sub-headline {\n      text-transform: uppercase;\n      margin: 0;\n      text-align: center;\n      font-weight: 600;\n      color: #2067d1;\n    }\n  }\n\n  .client-slide {\n    display: flex;\n\n    .item {\n      margin: 1px 15px;\n      background-color: #fff;\n      box-shadow: 5px 8px 26px 6px #00000008;\n      border-bottom: 7px solid #fff0;\n\n      p.normal {\n        font-weight: 500;\n        font-size: 12px;\n        letter-spacing: 0.2px;\n      }\n\n      p.project {\n        font-size: 12px;\n        margin: 0;\n        font-weight: 900;\n        padding: 0;\n      }\n\n      .checked {\n        color: #fff;\n        background-color: #2067d1;\n        font-size: 8px;\n        padding: 5px;\n        margin-bottom: 10px;\n      }\n\n      .title {\n        font-size: 16px;\n        padding-bottom: 5px;\n        margin: 0;\n      }\n\n      &:hover {\n        border-bottom: 7px solid #2067d1;\n      }\n    }\n  }\n}\n\n.mail-section {\n  .container {\n    background-size: cover;\n    display: flex;\n    justify-content: end;\n    align-items: center;\n    min-height: 545px;\n\n    .headline {\n      margin-right: 13%;\n      margin-bottom: -1.2%;\n\n      .h3 {\n        font-family: Lato, sans-serif;\n        font-size: 46px;\n        font-weight: 700;\n        color: #000;\n        margin: 0;\n      }\n\n      .sub-headline {\n        text-transform: uppercase;\n        margin: 0;\n        font-weight: 700;\n        color: #000;\n        font-size: 17px;\n        padding-bottom: 10px;\n      }\n\n      input {\n        border-radius: 10px;\n        font-size: 13px;\n        margin-bottom: 12px;\n        background-color: #ffffffb8;\n        min-height: 40px;\n      }\n\n      button {\n        margin-top: 10;\n        font-size: 12px;\n        text-transform: uppercase;\n        letter-spacing: 1px;\n        font-weight: 500;\n        border-radius: 10px;\n      }\n\n      .btn-dark {\n        background-color: #000;\n        border-radius: 8px;\n        color: #fff;\n      }\n    }\n  }\n}\n\n.main-con {\n  .content {\n    padding: 20px 0;\n\n    .row {\n      align-items: center;\n    }\n\n    .h1 {\n      font-family: Jost, sans-serif;\n      font-size: 35px;\n      font-weight: 700;\n      color: #000;\n\n      span {\n        color: #2067d1;\n      }\n    }\n\n    .h2 {\n      font-family: Jost, sans-serif;\n      font-size: 30px;\n      font-weight: 700;\n      color: #000;\n\n      span {\n        color: #2067d1;\n      }\n    }\n\n    .h3 {\n      font-family: Lato, sans-serif;\n      font-size: 25px;\n      font-weight: 700;\n      color: #000;\n\n      span {\n        color: #2067d1;\n      }\n    }\n\n    .p_n {\n      font-family: Inter, sans-serif;\n      font-size: 16px;\n      color: #3f3f3f;\n      /* letter-spacing: 0.2px; */\n    }\n  }\n}\n\nfooter {\n  .top-footer {\n    padding: 100px 0;\n    background-color: #121212;\n\n    .footer-logo {\n      max-width: 200px;\n      padding: 15px 0;\n    }\n\n    p.normal {\n      font-family: Jost, sans-serif;\n      font-size: 16px;\n      color: #fff;\n      letter-spacing: 0.2px;\n    }\n\n    .headline {\n      font-family: Jost, sans-serif;\n      font-size: 26px;\n      color: #fff;\n      font-weight: 600;\n      margin-bottom: 30px;\n      letter-spacing: 1px;\n    }\n\n    li {\n      font-family: Lato, sans-serif;\n      list-style: none;\n      font-size: 14px;\n      font-weight: 600;\n      color: #ececec;\n      line-height: 2.6;\n\n      &.add {\n        line-height: 30px;\n        color: #ffffffb8;\n        font-weight: 400;\n        padding: 0 0 12px;\n      }\n\n      &.subhead {\n        font-size: 12px;\n        text-transform: uppercase;\n        line-height: 0;\n        padding: 0 0 5px;\n      }\n\n      .fa-phone {\n        transform: rotate(90deg);\n      }\n\n      &.blog-footer {\n        line-height: 1.6;\n        margin-bottom: 20px;\n\n        small {\n          color: #ffffff8a;\n        }\n      }\n\n      a {\n        color: #ececec;\n        text-decoration: none;\n        font-family: Lato, sans-serif;\n\n        &:hover {\n          color: #2067d1;\n        }\n      }\n    }\n\n    .social-links {\n      display: flex;\n      margin-top: 10px;\n\n      a {\n        color: #fff;\n      }\n\n      i {\n        font-size: 30px;\n        padding-right: 15px;\n      }\n    }\n  }\n\n  .bottom-footer {\n    background-color: #121212;\n\n    .container {\n      justify-content: center;\n      display: flex;\n      border-top: 1px solid #fff;\n      padding: 10px 0;\n    }\n\n    p {\n      font-family: Lato, sans-serif;\n      list-style: none;\n      font-size: 14px;\n      font-weight: 600;\n      color: #fff;\n      line-height: 2.6;\n      margin: 0;\n\n      a {\n        color: #fff;\n        text-decoration: none;\n\n        &:hover {\n          color: #2067d1;\n        }\n      }\n    }\n  }\n}\n\n@media (width <= 1200px) and (width >= 676px) {\n  header nav .navbar-nav .nav-link a.link {\n    font-size: 12px;\n  }\n \n}\n\n@media (width <= 1080px) and (width >= 676px) {\n  .form-top-home {\n    .container {\n      position: static;\n      transform: translate(0, 0);\n    }\n\n    .form {\n      display: block;\n\n      .form-group {\n        margin-right: 0;\n      }\n    }\n  }\n}\n\n@media (width <= 676px) {\n  .about-us {\n    & .headline {\n  .sub-headline {\n    text-transform: uppercase;\n    margin: 0;\n    font-weight: 600;\n    color: #2067d1;\n    text-align: center;\n  }\n}\n  }\n\n  .about-us {\n    & .headline {\n  h3 {\n    text-transform: uppercase;\n    margin: 0;\n    font-weight: 600;\n    color: black;\n    text-align: center;\n  }\n}}\n\n.theme-btn {\n  margin: auto;\n}\n\n.CTA .callnow {\n  background-color: #2067d1;\n  color: #fff;\n  font-size: 16px;\n  padding: 6px 28px;\n  flex-basis: 50%;\n  justify-content: center;\n  display: flex;\n  align-items: center;\n}\n\n.CTA .whatsapp {\n    background-color: #058735;\n    color: #fff;\n    padding: 6px 28px;\n    flex-basis: 50%;\n    font-size: 16px;\n    align-items: center;\n    justify-content: center;\n    display: flex\n;\n}\n\n.CTA .whatsapp a,.CTA .callnow a{\n  font-size: 18px;\n  color: white;\n}\n\n.CTA {\n    display: flex;\n    position: fixed;\n    z-index: 999;\n    bottom: 0;\n    width: 100%;\n}\n\n  .main-slider h2 {\n    font-size: 40px;\n  }\n\n  .border-r {\n    border-radius: 0 0 10px 10px !important;\n  }\n\n  .form-top-home {\n    .form {\n      .form-group {\n        input[type=\"text\"] {\n          width: 100%;\n          padding: 5px 15px;\n        }\n\n        select {\n          padding: 5px 10px;\n        }\n\n        button {\n          margin: auto;\n          margin-top: 10px;\n          min-height: 40px;\n          display: block;\n          border-radius: 0 0 10px 10px;\n          width: auto;\n        }\n      }\n\n      .form-group {\n        &:last-child select {\n          border-radius: 0 0 10px 10px;\n        }\n      }\n    }\n  }\n\n  .contactUs {\n    .contactUsinner {\n      padding: 31px !important;\n    }\n  }\n\n  .top-header {\n    .container {\n      display: block;\n      text-align: center;\n\n      p {\n        justify-content: center;\n        font-family: second-font;\n\n        &:last-child {\n          display: none;\n        }\n      }\n    }\n  }\n\n  header nav .navbar-nav .nav-link {\n    padding: 11px 20px !important;\n    border-bottom: 1px solid #c5c5c5;\n  }\n\n  .form-top-home {\n    .container {\n      position: static;\n      transform: translate(0, 0);\n    }\n\n    .form {\n      display: block;\n      margin-right: 0;\n    }\n  }\n\n  .listing-home {\n    .headline {\n      .h3 {\n        font-family: Lato, sans-serif;\n        text-align: center;\n        font-size: 28px;\n      }\n\n      .head_p {\n        text-align: center;\n        font-size: 16px;\n      }\n    }\n\n    .custom-nav-mobi {\n      display: block;\n      text-align: center;\n\n      .owl-prev {\n        border: 0;\n        padding: 0 25px 10px;\n        font-size: 35px;\n        border-radius: 100%;\n      }\n\n      .owl-next {\n        border: 0;\n        font-size: 35px;\n        padding: 0 25px 10px;\n        border-radius: 100%;\n      }\n    }\n\n    .listing-slide {\n      .card-im {\n        border-radius: 15px;\n        width: 330px;\n        max-width: 100%;\n        background-color: #f7f7f7;\n        padding: 15px;\n\n        .details {\n          span {\n            display: block;\n          }\n        }\n\n        .fa-arrow-right {\n          display: none;\n        }\n\n        .location_im {\n          padding: 10px 0;\n          font-size: 13px;\n        }\n      }\n    }\n  }\n\n  .mail-section {\n    .container {\n      background-repeat: no-repeat;\n      display: block;\n\n      .headline {\n        margin-right: 0;\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .weWork {\n    .headline {\n      .h3 {\n        font-family: Lato, sans-serif;\n        font-size: 28px;\n      }\n    }\n\n    .weWorkInner {\n      flex-wrap: wrap;\n\n      .item {\n        flex-basis: 50%;\n      }\n    }\n  }\n\n  .testimonial {\n    .headline {\n      .h3 {\n        font-family: Lato, sans-serif;\n        font-size: 28px;\n      }\n    }\n  }\n\n  .home-blog {\n    .headline {\n      .h3 {\n        font-family: Lato, sans-serif;\n        font-size: 28px;\n      }\n    }\n  }\n\n  footer {\n    .top-footer {\n      padding: 30px 0;\n\n      .footer-logo {\n        margin: auto;\n        display: block;\n      }\n\n      .normal {\n        text-align: center;\n      }\n\n      .social-links {\n        justify-content: center;\n      }\n\n      .headline {\n        text-align: center;\n        border-top: 1px solid #00000026;\n        padding-top: 20px;\n        margin-bottom: 5px;\n      }\n\n      li {\n        text-align: center;\n\n        &:last-child {\n          padding-bottom: 20px;\n        }\n      }\n    }\n  }\n\n  .client_slider {\n    display: flex;\n    padding: 0;\n  }\n\n  .custom-nav {\n    display: none;\n  }\n\n  .mobiHide {\n    display: none;\n  }\n}\n\n.testimonial {\n  .owl-prev {\n    width: 15px;\n    height: 100px;\n    position: absolute;\n    top: 35%;\n    margin-left: -15px;\n    display: block !important;\n    border: 0 solid black;\n  }\n\n  .owl-next {\n    width: 15px;\n    height: 100px;\n    position: absolute;\n    top: 35%;\n    right: -15px;\n    display: block !important;\n    border: 0 solid black;\n  }\n\n  .owl-prev span,\n  .owl-next span {\n    color: #000;\n    font-weight: 600;\n    font-size: 40px;\n  }\n}\n\n.call-btn a {\n  font-family: Lato, sans-serif;\n  border-radius: 10px;\n  padding: 11px 28px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff !important;\n  background-color: #2067d1;\n  border: 2px solid #2067d1;\n  text-decoration: none;\n  margin-left: 20px;\n\n  &:hover {\n    border-radius: 10px;\n    padding: 11px 28px;\n    border: 2px solid #2067d1;\n    font-weight: 600;\n    text-decoration: none;\n    color: #2067d1 !important;\n    background-color: #fff;\n  }\n}\n\nul{\n  padding: 0;\n}\n\n.listing-page {\n  .listing-slide {\n    .card-im {\n      margin-bottom: 30px;\n      padding: 25px;\n\n      img {\n        object-fit: cover;\n        height: 263px;\n        border-radius: 24px;\n      }\n\n      .location_im {\n        min-height: 60px;\n      }\n    }\n  }\n}\n\n.details-header {\n  padding: 30px 0 0;\n  background-color: #fcfdfe;\n\n  .row {\n    align-items: center;\n\n    .col-md-6:last-child {\n      text-align: right;\n    }\n  }\n\n  .bubble {\n    background-color: #2067d1;\n    text-transform: uppercase;\n    font-size: 11px;\n    padding: 3px 7px;\n    color: #fff;\n    margin-right: 10px;\n  }\n\n  p {\n    margin: 0;\n  }\n\n  hr {\n    margin: 20px 0 0 !important;\n  }\n\n  .name {\n    font-size: 40px;\n    font-weight: 600;\n  }\n\n  .dev {\n    a {\n      color: #2067d1;\n      text-decoration: none;\n\n      &:hover {\n        color: #2067d1;\n        text-decoration: none;\n      }\n    }\n  }\n\n  .address {\n    padding-top: 15px;\n    color: #6e7079;\n    font-size: 14px;\n    font-weight: 500;\n  }\n\n  .price {\n    font-size: 30px;\n    font-weight: 600;\n\n    span {\n      font-size: 18px;\n    }\n  }\n\n  .emi-link {\n    a {\n      color: #2067d1;\n      text-decoration: none;\n      font-weight: 500;\n\n      &:hover {\n        color: #2067d1;\n        text-decoration: none;\n      }\n    }\n  }\n}\n\n.details-gallery {\n  background-color: #fcfdfe;\n\n  .row {\n    padding: 0;\n\n    .col-md-6 {\n      padding: 0;\n\n      img {\n        width: 760px;\n        height: 500px;\n      }\n    }\n\n    .col-md-3 {\n      padding: 0;\n    }\n\n    img {\n      width: 380px;\n      height: 250px;\n      object-fit: cover;\n    }\n  }\n}\n\n.details-content {\n  background-color: #fcfdfe;\n  padding: 30px;\n\n  .box {\n    background-color: #ffffff3d;\n    margin-bottom: 30px;\n    border-radius: 6px !important;\n    box-shadow: 2px 2px 5px 0 #00000014;\n    \n    .floor_item {\n      width: 350px;\n      box-shadow: 0 1px 4px 0 #006ac233;\n      margin: 10px;\n      padding: 0 20px 20px;\n      border-radius: 8px;\n\n      img {\n        width: 100%;\n      }\n\n      p {\n        font-weight: 700;\n        color: #000 !important;\n        font-size: 18px;\n      }\n\n      .btn {\n        background-color: #2067d1;\n        color: #fff;\n        font-weight: 500;\n      }\n    }\n\n    .calculate {\n      padding: 10px;\n      margin: 0;\n\n      .calheadline {\n        font-weight: 600;\n        font-size: 18px;\n      }\n\n      p {\n        margin: 0;\n        padding: 0;\n      }\n    }\n    \n    .headline {\n      border-bottom: solid 1px #e8e8e8;\n      padding: 12px 16px;\n      font-size: 15px;\n      background-color: #2067d1;\n      text-transform: uppercase;\n      letter-spacing: 0.2px;\n      font-weight: 700;\n      color: #fff;\n      border-radius: 6px 6px 0 0;\n    }\n\n    .inner-item {\n      padding: 10px 20px;\n\n      .over_head {\n        img {\n          border: 1px solid #727272;\n          margin-right: 10px;\n        }\n\n        display: flex;\n        align-items: center;\n\n        p {\n          margin: 0;\n        }\n      }\n\n      p {\n        color: #666;\n        font-family: second-font;\n      }\n\n      p.icon {\n        padding: 10px;\n        color: #2067d1;\n\n        i {\n          font-size: 20px;\n        }\n      }\n\n      .amenities {\n        color: #000;\n        line-height: 18px;\n      }\n     \n    }\n  }\n\n  .amenities {\n    li {\n      list-style: none;\n\n      img {\n        width: 35px;\n        margin-right: 10px;\n      }\n    }\n\n    .amenities-item {\n      padding: 10px;\n      display: flex;\n      align-items: center;\n    }\n  }\n\n  .item-fq {\n    margin-bottom: 12px;\n\n    .accordion {\n      border: 0;\n      width: 100%;\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      text-align: left;\n      font-family: Lato, sans-serif;\n      padding: 7px 12px;\n    }\n    \n  }\n}\n\n.right-sti {\n  position: sticky;\n  top: 67px;\n}\n\n.details-form {\n  background-color: #fff;\n  padding: 20px;\n  box-shadow: 2px 2px 5px 0 #00000014;\n  border-radius: 6px !important;\n  margin-bottom: 30px;\n\n  .form-control {\n    margin-bottom: 15px;\n    border-radius: 4px;\n    height: 40px;\n  }\n\n  .theme-btn {\n    border-radius: 4px;\n    height: 40px;\n    padding: 5px 20px;\n    font-size: 14px;\n    width: 100%;\n  }\n\n  .form-headline {\n    text-align: center;\n    font-size: 18px;\n    font-weight: 500;\n  }\n\n  .phone_num {\n    select {\n      border-radius: 4px 0 0 4px;\n      width: 25%;\n      border-right: 0;\n    }\n\n    input {\n      border-radius: 0 4px 4px 0;\n    }\n  }\n}\n\n\n.tab {\n  overflow: hidden;\n\n  .tablinks {\n    font-weight: 500;\n\n    i {\n      font-size: 12px;\n      color: #000;\n    }\n  }\n}\n\n.tab button {\n  background-color: #fff0;\n  float: left;\n  border: 0;\n  outline: 0;\n  cursor: pointer;\n  padding: 4px 16px;\n  transition: 0.3s;\n  font-size: 17px;\n  border-bottom: 4px solid #000;\n}\n\n.tab button:hover {\n  background-color: #fff0;\n}\n\n.tab button.active {\n  background-color: #fff0;\n  color: #2067d1;\n  font-weight: 700;\n  border-bottom: 4px solid #2067d1;\n}\n\n.tab button.active i {\n  color: #000;\n}\n\n.tabcontent {\n  display: none;\n  margin-top: 0;\n  padding: 6px 0;\n  border-top: 0;\n\n  .tab_price {\n    display: flex;\n    padding: 10px 10px 0;\n    justify-content: space-between;\n\n    p {\n      margin-bottom: 7px;\n      font-family: second-font;\n    }\n  }\n\n  .tabf {\n    overflow: hidden;\n    border-bottom: 1px solid #ccc;\n  }\n\n  .tabf button {\n    background-color: inherit;\n    float: left;\n    border: 0;\n    outline: 0;\n    cursor: pointer;\n    padding: 4px 16px;\n    transition: 0.3s;\n    font-size: 14px;\n  }\n\n  .tabf button.activef {\n    background-color: #fbfbfb;\n    font-weight: 700;\n  }\n\n  .tabcontentf {\n    display: none;\n    padding: 6px 12px;\n    border-top: 0;\n\n    .tab_price {\n      display: flex;\n      padding: 10px 10px 0;\n      justify-content: space-between;\n\n      p {\n        margin-bottom: 7px;\n        font-family: second-font;\n      }\n    }\n  }\n}\n\n.accordion {\n  background-color: #eee;\n  color: #444;\n  cursor: pointer;\n  margin-top: 20px;\n  width: 100%;\n  border: 0;\n  text-align: left;\n  outline: 0;\n  font-size: 15px;\n  transition: 0.4s;\n  border-radius: 5px;\n  padding: 5px 30px;\n}\n\n.active .accordion:hover {\n  background-color: #ccc;\n}\n\n.faqs {\n  .p_n {\n    margin-bottom: 4px;\n    font-size: 14px !important;\n    display: list-item;\n    list-style: disc inside;\n  }\n\n  .row {\n    align-items: baseline !important;\n  }\n}\n\n.contactUs {\n  .h1 {\n    padding: 0 0 25px;\n    text-align: center;\n  }\n\n  .container {\n    margin-top: -100px;\n  }\n\n  .contactUsinner {\n    padding: 80px 120px;\n    background-color: white;\n    position: relative;\n    box-shadow: 0 10px 50px #00000012;\n    margin: 0 auto 50px;\n\n    label {\n      padding: 15px 0 0;\n      margin: 0;\n      font-size: 13px;\n      font-weight: 500;\n      letter-spacing: 0.5px;\n    }\n\n    .form-control {\n      border-radius: 8px;\n      min-height: 45px;\n    }\n\n    .form {\n      max-width: 900px;\n      margin: auto;\n    }\n   \n    .cont_details {\n      align-items: center;\n      display: flex;\n      margin-bottom: 30px;\n\n      .mobile {\n        font-size: 20px;\n      }\n\n      i {\n        font-size: 30px;\n        color: #2067d1;\n        padding-right: 15px;\n      }\n\n      p {\n        margin: 0;\n        font-weight: 600;\n        font-family: Jost, sans-serif;\n      }\n\n      .blueBox {\n        background-color: #2067d1;\n        display: flex;\n        padding: 18px 32px;\n        color: #fff;\n        align-items: center;\n        border-radius: 30px;\n\n        i {\n          color: #fff;\n          font-size: 40px;\n        }\n      }\n    }\n  }\n}\n\n#ScrollTop {\n  display: none;\n  position: fixed;\n  bottom: 90px;\n  right: 15px;\n  z-index: 99;\n  font-size: 12px;\n  outline: 0;\n  border: 0;\n  background-color: #2067d1;\n  color: white;\n  cursor: pointer;\n  padding: 16px 20px;\n  border-radius: 50%;\n  box-shadow: 0 0 15px 0 #00000045;\n}\n\n#ScrollTop:hover {\n  background-color: #555;\n}\n\n\n@media (width >= 1200px) {\n  .container, .container-lg, .container-md, .container-sm, .container-xl {\n      max-width: 1400px;\n  }\n}\n\n.swiper{\n  padding: 26px !important;\n}\n\n.iticks-pop-button {\n  background: #0565f1!important;\n}\n\n.CTA{\ndisplay: none;\n}\n\n@media screen and (width <= 768px) {\n  .CTA {\n      display: flex; \n  }\n}\n\n.aRemove {\n  color: #000;\n}\n\na:hover{\n  text-decoration: none;\n  text-underline-offset: none;\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.5em + .75rem + 2px);\n  padding: .375rem 1.75rem .375rem .75rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.5;\n  color: #495057;\n  vertical-align: middle;\n  border: 1px solid #ced4da;\n  border-radius: .25rem;\n  appearance: none;\n}\n\n.table-bordered{\n  border: 1px solid #dee2e6;\n}\n\n.table>tbody {\n  border: 1px solid #dee2e6;\n}\n\n.table-bordered td {\n  font-weight: 600;\n  color: #14191e;\n  padding: .75rem;\n  vertical-align: top;\n}\n\n.table-bordered th{\n  font-weight: 400;\n  color: #212529;\n  padding: .75rem;\n  vertical-align: top;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
